import { render, staticRenderFns } from "./FirstProductAddedToList.vue?vue&type=template&id=350f5171"
import script from "./FirstProductAddedToList.vue?vue&type=script&lang=js"
export * from "./FirstProductAddedToList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports